<template>
  <div id="app">
    <NavBar v-if="!hideLayout" />
    <main :class="['main-container', { 'main-container--plain': hideLayout }]">
      <router-view />
    </main>
    <footer v-if="!hideLayout" class="site-footer">
      <div class="footer-inner">
        <p>© 2026 文常商服 版权所有</p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备2026017080号</a></p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏公网安备32010602012362号</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar
  },
  computed: {
    hideLayout() {
      const byMeta = Boolean(this.$route.meta && this.$route.meta.hideLayout)
      const routePath = this.$route.path || ''
      const byPath = routePath === '/bx1' || routePath.startsWith('/bx')
      return byMeta || byPath
    }
  },
  mounted() {
    this.$store.dispatch('fetchBanners')
    this.$store.dispatch('fetchPartners')
    this.$store.dispatch('fetchNews')
    this.$store.dispatch('fetchInsurance')
  }
}
</script>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #1f2933;
  background-color: #f5f7fa;
}

a {
  color: inherit;
  text-decoration: none;
}

img {
  max-width: 100%;
  display: block;
}

.main-container {
  padding-top: 72px;
  min-height: calc(100vh - 180px);
}

.main-container--plain {
  padding-top: 0;
  min-height: 100vh;
}

.site-footer {
  background: #0f213d;
  color: #cbd2e1;
  padding: 32px 16px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 13px;
  line-height: 1.8;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 999px;
  border: none;
  background: #1a3c6e;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.btn-primary:hover {
  background: #10294a;
  box-shadow: 0 8px 20px rgba(7, 16, 33, 0.35);
  transform: translateY(-1px);
}

.section {
  padding: 80px 16px;
}

.section-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: left;
  margin-bottom: 32px;
}

.section-title {
  font-size: 28px;
  color: #102a43;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: 12px;
  color: #7b8794;
  line-height: 1.6;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.card-body {
  padding: 20px 20px 22px;
}

.card-title {
  font-size: 18px;
  color: #102a43;
  margin-bottom: 8px;
}

.card-meta {
  font-size: 12px;
  color: #9fb3c8;
  margin-bottom: 10px;
}

.card-text {
  font-size: 14px;
  color: #52606d;
  line-height: 1.7;
}

@media (max-width: 1024px) {
  .card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .main-container {
    padding-top: 64px;
  }

  .main-container--plain {
    padding-top: 0;
  }

  .section {
    padding: 56px 16px;
  }

  .section-title {
    font-size: 22px;
  }

  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style>
